import styled from 'styled-components';

type Props = {
  small?: boolean;
  medium?: boolean;
  large?: boolean;
  custom?: number;
};

export const HorizontalSpacer = styled.div<Props>`
  display: block;
  min-width: ${({ custom, large, medium, small, theme }): string => {
    if (custom) {
      return `${custom}px`;
    }

    if (large) {
      return theme.spacing.base.xl;
    }

    if (medium) {
      return theme.spacing.base.md;
    }

    if (small) {
      return theme.spacing.base.xs;
    }

    // default value
    return theme.spacing.base.xs;
  }};
`;
